var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modals"},[_c('b-modal',{ref:"alerta",attrs:{"id":"alerta","title":"Alerta"}},[_c('b-alert',{attrs:{"show":"","variant":"warning"}},[_vm._v("Warning Alert")])],1),_c('b-modal',{ref:"sucesso",attrs:{"id":"sucesso","title":"Sucesso"}},[_c('b-alert',{attrs:{"show":"","variant":"success"}},[_vm._v("Success Alert")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }